
// Bulk add to cart script

var scriptElement = $("#wx-variants-data");
var sizesWrapper = $(".product-form__input-size");
if($(".product-form__input-size").length < 1){
  sizesWrapper = $(".product-form__input-taille");
}
var result = {};

$(function(){
  
  if (scriptElement.length) {
      sizesWrapper.find("input.netterms-qty").remove();
      try {
          var jsonData = JSON.parse(scriptElement.text());

          jsonData.forEach(function(item) {
              var colorOption = item.option1;
              var hasAgeGroup = typeof item.option3 !== 'undefined' && item.option3 !== null && item.option3 !== '';

              // Default mapping (Color + Size)
              if (!hasAgeGroup) {
                  if (!result[colorOption]) {
                      result[colorOption] = [];
                  }
                  result[colorOption].push({
                      id: item.id,
                      option2: item.option2,
                      price: item.price,
                      available: item.available
                  });

                  // append the sizes input (Color + Size)
                  var singleSizeDefault = sizesWrapper.find('[data-value="'+item.option2+'"]');
                  if(singleSizeDefault.length > 0){
                    var inputDefault = '<input type="number" class="wx-variant-qty netterms-qty" data-value="'+item.option2+'" data-option="option2" data-color="'+item.option1+'" data-size="'+item.option2+'" data-productid="'+item.id+'" min="0" step="1">';
                    singleSizeDefault.append(inputDefault);
                  }
              } else {
                  // Extended mapping (Color + Age Group + Size)
                  var ageGroupOption = item.option2;
                  var sizeOption = item.option3;

                  if (!result[colorOption]) {
                      result[colorOption] = {};
                  }
                  if (!result[colorOption][ageGroupOption]) {
                      result[colorOption][ageGroupOption] = [];
                  }
                  result[colorOption][ageGroupOption].push({
                      id: item.id,
                      option3: sizeOption,
                      price: item.price,
                      available: item.available
                  });

                  // append the sizes input (Color + Age Group + Size)
                  var singleSize = sizesWrapper.find('[data-value="'+sizeOption+'"]');
                  if(singleSize.length > 0){
                    var input = '<input type="number" class="wx-variant-qty netterms-qty" data-value="'+sizeOption+'" data-option="option3" data-color="'+colorOption+'" data-age-group="'+ageGroupOption+'" data-size="'+sizeOption+'" data-productid="'+item.id+'" min="0" step="1">';
                    singleSize.append(input);
                  }
              }
          });
          showSizes();
      } catch (error) {
          console.error("Error parsing JSON:", error);
      }
  } else {
      console.error("Script element with ID 'wx-variants-data' not found.");
  }
});

// show sizes on color and age group change
$(document).on('click' , '.product-form__input-color[data-option="option1"] .form-variant-option-wrap', showSizes);
$(document).on('click' , '.product-form__input-couleur[data-option="option1"] .form-variant-option-wrap', showSizes);
// English age group
$(document).on('click' , '.product-form__input-age-group[data-option="option2"] .form-variant-option-wrap', showSizes);
// French age group (tranche d'âge)
$(document).on('click' , '.product-form__input-tranche-dage[data-option="option2"] .form-variant-option-wrap', showSizes);
function showSizes(){ 
  var hasSizeFieldset = $(".product-form__input-size").length > 0;

  // Determine selected color (EN / FR)
  var colorWrapper = null;
  if(!hasSizeFieldset){
    if($('.product-form__input-couleur input[name="Couleur"]:checked').length){
      colorWrapper = $('.product-form__input-couleur input[name="Couleur"]:checked').parent('.form-variant-option-wrap');
    }
  } else{
    if($('.product-form__input-color input[name="Color"]:checked').length){
      colorWrapper = $('.product-form__input-color input[name="Color"]:checked').parent('.form-variant-option-wrap');
    }
  }

  var color = colorWrapper ? colorWrapper.data("value") : null;

  // Determine selected age group (if present – EN or FR)
  var ageWrapper = $('.product-form__input-age-group input[name="Age Group"]:checked').parent('.form-variant-option-wrap');
  if (!ageWrapper.length) {
    ageWrapper = $('.product-form__input-tranche-dage input[name="Tranche d\'âge"]:checked').parent('.form-variant-option-wrap');
  }
  var ageGroup = ageWrapper && ageWrapper.length ? ageWrapper.data("value") : null;

  sizesWrapper.find('input.wx-variant-qty').hide();

  // Build selector based on available filters
  var selector = 'input.wx-variant-qty';
  if(color){
    selector += '[data-color="'+color+'"]';
  }
  if(ageGroup){
    selector += '[data-age-group="'+ageGroup+'"]';
  }

  sizesWrapper.find(selector).show();
}

var root_url = "";
var saved_qty = {};

function multiAdd(keys) {
  if (keys.length) {
    var request = keys.shift(),
        temp = request,
        params = {
          type: 'POST',
          url: root_url +'/cart/add.js',
          data: temp,
          dataType: 'json',
          success: function(line_item) {
            setTimeout(function(){
              multiAdd(keys);
            },1500)
          },
          error: function(jqXHR, status, err) {
            console.log(jqXHR);
            console.log(status);
            console.log(err);
            setTimeout(function(){
              multiAdd(keys);
            },1500)
          }
        };
    $.ajax(params);
  } else {
    window.location = window.routes.cart_url;
  }
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      if(false && this.form.classList.contains('multi-add')){

        var key_array = [],
            key_object = {},
            props = {},
            count = Object.keys(saved_qty).length,
            productSingleObject = JSON.parse(this.querySelector('[type="application/json"]').textContent),
            product_variants = productSingleObject.variants,
            qty_total = window.shop.infos.cart.item_count;
        $.each(saved_qty,function(i,v){
          qty_total += v
        });
        var shippingJson = JSON.parse(document.getElementById('shippingJSON').innerHTML),
            attributes = {};
        $.each(shippingJson.country,function(country,provinces){
          $.each(provinces[0],function(province,shipping_types){
            var key_string_single = 'shipping_single_'+ country +'_'+ province,
                key_string_multiple = 'shipping_multiple_'+ country +'_'+ province;
            attributes[key_string_single] = shipping_types[0]['single'];
            attributes[key_string_multiple] = shipping_types[0]['multiple'];
          });
        });
        $.each(saved_qty, function(variant,qty){
          var find_variant = $.grep(product_variants, function (element, index) {
                return element.id == variant;
              });
          var finalprice = variantsnetavailInventory.find((el) => el.variantid == find_variant[0].id).b2bprice,
              ffcents = finalprice.toFixed(0);
              const dataHandle = document.querySelector('.wx-phandle').getAttribute('data-handle');
          if(Cookies.get('netneed') == 'net_now' || Cookies.get('netneed') == 'net_preorder') {
            props = {'NETPRICE':ffcents, 'PREORDER': Cookies.get('netneed') == 'net_preorder' ? 'true' : 'false', 'Product Handle': dataHandle, 'Product Color': variantsnetavailInventory.find((el) => el.variantid == find_variant[0].id).b2bcolor, 'Variant ID': find_variant[0].id, 'Variant Price': find_variant[0].price, 'Variant Max Qty': variantsnetavailInventory.find((el) => el.variantid == find_variant[0].id).b2bqty }
          } else {
            props = {'NETPRICE':ffcents}
            $.extend( true, props, attributes );
          }
          if(window.shop.infos.domain.includes('us')){
            var poid = 45622363455645;
          }else if(window.shop.infos.domain.includes('eu')){
            var poid = 49319405748565;
          }else{
            var poid = "43308957794441";
          }
          
          key_object = {
            id: Cookies.get('netneed') != 'net_dropship' ? poid : find_variant[0].id,
            quantity: qty,
            properties: props
          };

          key_array.push(key_object);
          if (!--count && key_array.length > 0) {

            multiAdd(key_array);
          }
        });
        
      }else{

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
  
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
  
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
  
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
  
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            const shopTheLookModal = this.closest('modal-dialog');
            if (quickAddModal || shopTheLookModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(response) });
              }, { once: true });
              if (quickAddModal) {
                quickAddModal.hide(true);
              } else {
                shopTheLookModal.hide(true);
              }
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    multiItemAdd() {
      
    }
  });
}


